module.exports = __webpack_public_path__ + "static/media/ICONO-ESTRELLAS-IA.6d84d7fd.png";